import React from 'react'
import classes from './styles.module.scss'
// import { FormattedMessage } from 'react-intl'
import messages from './messages'
import { message } from 'antd'
import { CopyToClipboard as Copy } from 'react-copy-to-clipboard'
import { intl } from 'utils'

export default class CopyToClipboard extends React.Component {
  // constructor (props) {
  //   super(props)
  //   this.state = {
  //     foo: 'foo'
  //   }
  // }
  render() {
    const { children } = this.props
    return (
      <Copy
        text={children}
        onCopy={() => message.success(intl().formatMessage(messages.copied), 1)}
      >
        <div className={classes.componentsCopyToClipboard}>
          {children}
          <span className='iconfont fill_icon_secondary iconcopy font-16' />
        </div>
      </Copy>
    )
  }
}
